<template>
  <f7-page name='card'>
      <bc-navbar></bc-navbar>
      <div id="pages_maincontent">
          <a v-on:click="back">
                    <img src="/static/images/icons/black/back.png" alt="" style="margin-left:20px;" class="back_image_button" title="">
             </a>
            <div class="page_single layout_fullwidth_padding">
                <div class="content">
                     <br>         
                    <img src="/static/images/build-a-brand-logo.png" alt="">
                    <br>
                    <h4 class="title">Are you looking to build you business?</h4>
                    <br>
                    <p>Let us help you with the power of a personal brand and tools that drive sales.</p>
                    <ul>
                        <li>Get your own digital business card, just like you are using now!</li>
                        <li>Communicate to your prospects with video messages and chat</li>
                        <li>Recommend A Friend™ referral system to get your customer’s and friends to be an advocate for you</li>
                        <li>Build-A-Brand™ personal websites</li>
                        <li>Social Content and Strategy</li>
                        <li>Photo/Video Customer Testimonials</li>
                        <li>And so much more…</li>
                    </ul>
                    <br>
                    <input type="button" v-if="!cardData.isDemoUser && !saveRequest.isActive " value="Learn More" @click="submit" :style="borderStyle" class="button form_submit"/>
                    <div v-if="saveRequest.isActive" class="loader">
                      <looping-rhombuses-spinner v-if="!saveRequest.isSuccess" :animation-duration="2500" :rhombus-size="15" :color="spinnerColor" />
                      <div class="success_msg" v-if="saveRequest.isSuccess">
                        <img src="/static/images/icons/black/success.png" alt="" class="success_icon" title="">
                        <div style="margin-left: 10px;">Request sent!</div>
                      </div>
                    </div>
                  <br>
                  <p class="text-center">Visit us a <a @click="onVisitClick">www.BuildaBrand.com</a></p>
                </div>
            </div>
    </div>
  </f7-page>
</template>
<script>
/* eslint-disable */
import { LoopingRhombusesSpinner } from "epic-spinners";
import config from '../../config/customer.api'
import {Request} from '../shared/base.requests'
import {mask} from 'vue-the-mask'
import { mapState } from 'vuex'

export default {
      components: {
    LoopingRhombusesSpinner
  },
  directives: {mask},
  mounted:function() { 
    this.getCard();
 },
   computed:{ 
      ...mapState({
      customization: state => state.common.customization
    }),
     borderStyle: function(){     
      var borderStyle = this.customization.borderOn ? 'solid 1px ' + this.customization.borderColor :  'none';
      var backgroundStyle = this.customization.mainColor;
      var colorStyle = this.customization.fontColor
      return {
        border: borderStyle, 
        background: backgroundStyle,
        color:colorStyle
      };
     },
     spinnerColor: function(){     
      return this.customization.mainColor;
     }
  },
  methods: {
    back () {
      window.history.back()
    },
    getCard () {
      return new Promise((resolve, reject) => {
        this.isRequestActive = true
          Request.get(config.getUserCardData)
          .then(response => {
            this.cardData = response;
            this.isLoadData = true;
            console.log(this.cardData);
            this.isRequestActive = false;
            resolve();
          })
          .catch(error => {
            this.isRequestActive = false;
            console.error("loadUserProfile failed", error);
            reject();
          });
      });
    },
    submit () {
        if(this.cardData.mobilePhone) {
        new Promise((resolve, reject) => {
            this.saveRequest.isActive = true;
            Request
            .post(config.saveUserCardData)
            .then(response => {
                console.log("CARD resp",response);
                this.saveRequest.isSuccess = true;
                resolve(response);
            })
            .catch(error => {
                console.error("save card failed", error);
                this.saveRequest.isActive = false;
                reject(error);
            });
        });
        window.open('http://www.buildabrand.com', '_blank');
      }
    },
    onVisitClick () {
      window.open('http://www.buildabrand.com', '_blank')
    }
  },
  data () {
    return {
      cardData: {
        firstName: "",
        lastName: "",
        mobilePhone: "",
        email: "",
        companyName: "",
        salespersonName: "",
        isDemoUser: true,
      }, 
      isLoadData:false,   
      isRequestActive: false,
      saveRequest:{
        isActive:false,
        isSuccess:false
      },
    };
  }
}
</script>
<style scoped>
    .content{
        text-align: center;
    }
    .content h4{
        font-weight: bold;
    }
    .content ul{
        list-style: disc;
        text-align: left;
        padding: 0 20px;
    }
    .content button{
        max-width:300px; 
        margin:0 auto;
    }
    .content img{
        margin: auto;
    }
    #pages_maincontent{
        padding-top: 20px;
        overflow: auto;
    }

    .loader {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgb(255, 255, 255);
    text-align: center;
    z-index: 100;
    }
    .looping-rhombuses-spinner {
    display: inline-block;
    }
    .success_icon {
    width: 30px;
    height: 30px;
    display: block;
    }
    .success_msg{
    display: flex;
    justify-content: space-around;
    align-content: center;
    margin-bottom: 20px;
    }
    .success_msg > *
    {
    margin:unset;
    }
    .none {
    display: none;
    }
    .list-block .item-content{
    -webkit-justify-content: flex-start;
        justify-content: flex-start;
    }
    .form_row_right {
        border-bottom: 1px solid #d6d6d6;
    }
    .font-red{
    color:red !important;
    }
    .text-center{
        text-align: center;
    }
    .button{
        max-width: 300px;
        margin: auto;
    }
</style>




// WEBPACK FOOTER //
// card.vue?7105ec2e